import { INPUT_MESSAGES_MAX_ITEMS } from 'Constants'
import debounce from 'lodash/debounce'
import { Select, SELECT_VARIANT_WITH_CHECKBOX } from 'mailup-web-components'
import { filterMessagesCallback } from 'Pages/WorkflowsList/recoil/callbacks/callbacks'
import {
  messagesState,
  searchState
} from 'Pages/WorkflowsList/recoil/state/search'
import { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

export const InputMessages = () => {
  const intl = useIntl()

  const [{ filterMessages: value, filterMessagesSelected }, setSearch] =
    useRecoilState(searchState)
  const { count, items, loading } = useRecoilValue(messagesState)
  const [options, setOptions] = useState([])
  const [searchString, setSearchString] = useState()
  const filterMessage = useRecoilCallback(filterMessagesCallback)

  // useEffect(() => {
  //   filterMessage('')
  // }, [])

  // reset della ricerca
  useEffect(() => {
    searchString === '' && filterMessage('')
  }, [searchString])

  useEffect(() => {
    // l'utente ha selezionato o deselezionato un item
    const fMessages = filterMessagesSelected
    // aggiungo i selezionati della lista corrente
    items
      .filter((f) => value.find((valId) => valId === f.id))
      .forEach((e) => {
        fMessages.set(e.id, { value: e.id, label: `${e.id} - ${e.subject}` })
      })
    // rimuovo quelli non più presenti
    for (const xId of fMessages.keys()) {
      if (!value.find((valId) => valId === xId)) {
        fMessages.delete(xId)
      }
    }
    setSearch((prev) => ({
      ...prev,
      filterMessagesSelected: fMessages
    }))
  }, [value])

  useEffect(() => {
    // lista da API
    const optionsUpdated = [
      ...items.map(({ id, subject }) => ({
        value: id,
        label: `${id} - ${subject}`
      }))
    ]
    // lista dei selezionati nella mappa
    for (const mapVal of filterMessagesSelected.values()) {
      !optionsUpdated.find((e) => e.value === mapVal.value) &&
        optionsUpdated.unshift(mapVal) // merge delle due liste: lista da API + lista dei selezionati nella mappa
    }
    setOptions(optionsUpdated)
  }, [items])

  const { current: fetch } = useRef(
    debounce(async (value) => {
      await filterMessage(value)
    }, 250)
  )

  const handleSearch = (value) => {
    setSearchString(value)
    if (!value) {
      return value
    }
    fetch(value)
    return value
  }

  const handleChange = (value) => {
    setSearch((prev) => ({
      ...prev,
      filterMessages: value
    }))
  }

  const handleExpandCollapse = (expanded) => {
    if (!expanded) {
      setSearchString('')
    }
  }

  const hint = () => {
    if (!count && !loading && searchString !== '') {
      return intl.formatMessage({
        id: 'Load.MailupCommon.InputStatusNoMatches'
      })
    }
    if (count > INPUT_MESSAGES_MAX_ITEMS) {
      return intl.formatMessage({
        id: 'Load.Filters.ActivityMessagesMoreResults'
      })
    }
    if (loading) {
      return intl.formatMessage({
        id: 'Load.MailupCommon.InputStatusLoading'
      })
    }
  }

  return (
    <Select
      multiple
      variant={SELECT_VARIANT_WITH_CHECKBOX}
      value={value}
      placeholder={intl.formatMessage({
        id: 'Load.AutomationWorkflow.SearchMessagePlaceholder'
      })}
      onChange={handleChange}
      onSearch={handleSearch}
      onExpandCollapse={handleExpandCollapse}
      options={options}
      hint={hint()}
      data-mu-test='select--messages'
    />
  )
}
